<template>
	<div class="dictionaryClassify">
		<div class="headerBox">
			<span>字典分类</span>
			<el-button type="primary" plain @click="backClick()" class="addButtonClass" style="right:150px">返回</el-button>
			<el-button type="primary" plain @click="addClick()" class="addButtonClass">新建一级字典分类</el-button>
		</div>
		<div class="tableBox">
			<el-table :data="tableData" style="width: 100%" v-loading="loading">
				<el-table-column label="序 号" width="70">
					<template slot-scope="scope"><span style="padding-left: 4px;">{{(pageIndex-1)*pageSize+scope.$index+1}}</span></template>
				</el-table-column>
				</el-table-column>
				<el-table-column prop="title" label="分类名称" min-width="2%">
					<template slot="header" slot-scope="scope">
						<span style="vertical-align: middle;">分类名称</span>
					</template>
				</el-table-column>
				<el-table-column prop="lowerLevel" label="下级分类" min-width="7%">
					<template slot="header" slot-scope="scope">
						<span style="vertical-align: middle;">下级分类</span>
					</template>
				</el-table-column>
				<el-table-column prop="" label="操作" min-width="2%">
					<template slot="header" slot-scope="scope">
						<span style="vertical-align: middle;">操作</span>
					</template>
					<template slot-scope="scope">
						<a class="editClass" @click.prevent="editClick(scope.row.id,scope.row)">编辑</a>
						<a class="editClass" @click.prevent="addClick(scope.row.id,scope.row)">新建子分类</a>
						<a class="editClass" @click.prevent="deleteClick(scope.row.id,scope.row)">删除</a>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="pagination">
			<!--<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[20, 50, 100, 200]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" v-if="total>20">
			</el-pagination>-->
		</div>
		<!--弹窗-->
		<el-dialog :title="title" :visible.sync="dialogFormVisible" :width="dialogWidth" :close-on-click-modal="false">
			<div style="position: relative;">
				<el-form>
					<el-form-item label="名称" label-width="20%" style="position: relative;">
						<el-input type="text" v-model="titleVal" autocomplete="off" style="width:90%"></el-input>
						<i class="iconfont icon-jiufuqianbaoicon14 xinghaoClass"></i>
					</el-form-item>
				</el-form>
			</div>

			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible=false" class="cancle">取消</el-button>
				<el-button @click="save()" class="confrim" type="primary">立即创建</el-button>
			</div>
		</el-dialog>
		<!--编辑弹窗-->
		<el-dialog :title="title" :visible.sync="dialogFormVisible2" :width="dialogWidth" :close-on-click-modal="false">
			<div style="position: relative;" v-for="item in rowList">
				<div>
					名称：<input v-model="item.title" class="groupClass"></input>
				</div>
				<div class="groupClass2Box" v-for="vs in item.children">
					<input v-model="vs.title" class="groupClass2"></input>
					<i class="el-icon-error" style="color: #666;font-size: 18px;" @click="deleteClickCopy(vs.id)"></i>
				</div>

			</div>
			<div class="sp2">
				<div slot="footer" class="dialog-footer" style="text-align: center!important;margin-top: 20px;">
					<el-button @click="dialogFormVisible2=false" class="cancle">取消</el-button>
					<el-button @click="save2()" class="confrim" type="primary">立即创建</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { mapGetters, mapActions } from 'Vuex';
	import headers from '../../../static/js/headers.js'
	import dataList from '../../../static/js/dataList.js'
	import md5 from '../../../static/js/md5.js'
	import qs from 'qs'
	import axios from 'axios'
	export default {
		mounted() {
			if(this.$route.query.fI) {
				this.pageIndex = this.$route.query.fI
			}
			if(typeof(this.pageIndex) != 'number') {
				this.pageIndex = Number(this.pageIndex)
			}
			this.getList();
			window.addEventListener('resize', () => {
				if(document.body.clientWidth < 767) {
					this.dialogWidth = "100%"
				} else if(document.body.clientWidth < 1200) {
					this.dialogWidth = "64%"
				} else {
					this.dialogWidth = "40%"
				}
			})
		},
		created() {
			if(document.body.clientWidth < 767) {
				this.dialogWidth = "100%"
			} else if(document.body.clientWidth < 1200) {
				this.dialogWidth = "64%"
			} else {
				this.dialogWidth = "40%"
			}
		},
		computed: {
			...mapGetters(['http'])
		},
		data() {
			return {
				loading: false, //加载状态
				pageSize: 20, //每页条数
				pageIndex: 1, //当前页
				total: 0, //总条数
				tableData: [],
				dialogFormVisible: false,
				dialogFormVisible2: false,
				title: '', //弹窗标题
				titleVal: '',
				dialogWidth: '40%', //dialog的宽度
				nameInput: '',
				rowList: [],
				editId: '',
				parent_id: '',
			}
		},
		methods: {
			//返回
			backClick() {
				this.$router.push({
					path: '/dictionaryManage/dictionaryManage',
					name: 'DictionaryManage'
				})
			},
			//编辑的点击
			editClick(id, list) {
				this.rowList = []
				this.dialogFormVisible2 = true
				this.title = '编辑字典分类'
				this.rowList.push(list)
				this.editId = list.id
			},
			//每页多少
			handleSizeChange(val) {
				this.pageSize = val;
				this.getList();
			},
			//更改页数
			handleCurrentChange(val) {
				this.pageIndex = val;
				this.getList();
			},
			//总条数
			getTotal() {
				var params = {
					pageSize: this.pageSize,
					pageIndex: this.pageIndex,
				}
				let config = headers.headers('getListByLimitCount')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/title_category/getListByLimitCount', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data) {
						this.total = res.data
					} else {
						this.total = 0
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//获取列表
			getList() {
				this.loading = true;
				var params = {
					pageSize: -1,
					pageIndex: 1,
				}
				//console.log(params)
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/title_category/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					this.loading = false
					this.getTotal();
					//console.log(res)
					if(res.data.length > 0) {
						this.tableData = this.listToTree(res.data)
						console.log(this.tableData)
					} else {
						this.tableData = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//处理子列表为树状结构
			listToTree(list) {
				//遍历整个列表
				return list.filter(cur => {
					// 获取当前节点的子节点
					let children = list.filter(item => item.parent_id == cur.id);
					if(children.length > 0) {
						cur.children = children;
						cur.lowerLevel = ''
						children.forEach((v, i) => {
							if(i + 2 <= children.length) {
								cur.lowerLevel += String(v.title) + '、';
							} else {
								cur.lowerLevel += String(v.title);
							}
						})
					}
					//只返回顶级节点
					return cur.parent_id == 0;
				});

			},
			//新增分类
			addClick(id) {
				this.emptyList();
				this.parent_id = id
				this.dialogFormVisible = true
				if(id) {
					this.title = "新建字典二级分类"
				} else {
					this.title = "新建字典一级分类"
				}
			},
			//一级、二级字典的保存
			save() {
				/*创建时间的处理*/
				var timestamp = Date.parse(new Date());
				var manager_id = window.sessionStorage.getItem('id')
				var parent_id = null
				if(this.title == '新建字典二级分类') { //二级
					parent_id = this.parent_id
				} else if(this.title == '新建字典一级分类') {
					parent_id = 0
				}
				var params = {
					parent_id: parent_id,
					status: 1,
					title: this.titleVal,
					manager_id: manager_id,
					create_time: timestamp,
				}
				//console.log(params)
				let config = headers.headers('save')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				if(this.titleVal) {
					axios.post(this.http + '/zkep2/title_category/save',
						qs.stringify(params), {
							headers: {
								'pass-token': pass_token,
								'time': timestamp
							}
						}).then(res => {
						//console.log(res)
						if(res.data.id) {
							this.dialogFormVisible = false
							this.getList()
							this.emptyList()
						} else {
							this.$message('新增失败！')
						}
					}).catch(err => {
						console.log(err)
					})
				} else {
					this.$message('请输入必填项！')
				}
			},
			//编辑的保存
			async save2() {
				/*创建时间的处理*/
				var timestamp = Date.parse(new Date());
				var manager_id = window.sessionStorage.getItem('id')
				let config = headers.headers('save')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				for(var i = 0; i < this.rowList.length; i++) {
					if(this.rowList[i].title) {
						const res1 = await axios.post(this.http + '/zkep2/title_category/save',
							qs.stringify({
								id: this.rowList[i].id,
								status: 1,
								title: this.rowList[i].title,
								manager_id: manager_id,
								create_time: timestamp,
							}), {
								headers: {
									'pass-token': pass_token,
									'time': timestamp
								}
							}).then(res => {
							//console.log(res)
							if(res.data.id) {} else {
								this.$message('新增失败！')
							}
						}).catch(err => {
							console.log(err)
						})
					} else {
						this.$message('请输入必填项！')
					}
					if(this.rowList[i].children && this.rowList[i].children.length > 0) {
						for(var j = 0; j < this.rowList[i].children.length; j++) {
							if(this.rowList[i].title) {
								const res2 = await axios.post(this.http + '/zkep2/title_category/save',
									qs.stringify({
										id: this.rowList[i].children[j].id,
										status: 1,
										title: this.rowList[i].children[j].title,
										manager_id: manager_id,
										create_time: timestamp,
									}), {
										headers: {
											'pass-token': pass_token,
											'time': timestamp
										}
									}).then(res => {
									//console.log(res)
									if(res.data.id) {
										this.dialogFormVisible2 = false
										this.getList()
									} else {
										this.$message('新增失败！')
									}
								}).catch(err => {
									console.log(err)
								})
							} else {
								this.$message('请输入必填项！')
							}
						}
					} else {
						this.getList()
						this.dialogFormVisible2 = false
					}
				}
			},
			//编辑的删除
			deleteClickCopy(id) {
				let config = headers.headers('save')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				this.$confirm('', '', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					message: '注意<br>' + "确认要删除吗？",
					dangerouslyUseHTMLString: true,
				}).then(() => {

					axios.post(this.http + '/zkep2/title_category/save', qs.stringify({
						id: id,
						status: 0
					}), {
						headers: {
							'pass-token': pass_token,
							'time': timestamp
						}
					}).then(res => {
						//console.log(res)
						if(res.data.id) {
							this.getList();
							this.rowList.forEach(item=>{
								item.children.forEach((v,i)=>{
									if(v.id==res.data.id){
										item.children.splice(i, 1);
									}
								})
							})
						} else {
							this.$message({
								type: 'error',
								message: '删除失败!'
							});
						}
					}).catch(err => {
						console.log(err)
					})

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			//删除
			deleteClick(id, list) {
				var ids = []
				ids.push(id)
				if(list.children && list.children.length > 0) {
					list.children.forEach(item => {
						ids.push(item.id)
					})
				}
				let config = headers.headers('save')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				this.$confirm('', '', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					message: '注意<br>' + "确认要删除吗？",
					dangerouslyUseHTMLString: true,
				}).then(() => {
					for(var i = 0; i < ids.length; i++) {
						axios.post(this.http + '/zkep2/title_category/save', qs.stringify({
							id: ids[i],
							status: 0
						}), {
							headers: {
								'pass-token': pass_token,
								'time': timestamp
							}
						}).then(res => {
							//console.log(res)
							if(res.data.id) {
								this.getList();
							} else {
								this.$message({
									type: 'error',
									message: '删除失败!'
								});
							}
						}).catch(err => {
							console.log(err)
						})
					}

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			//清空
			emptyList() {
				this.titleVal = ''
				this.editId = ''
				this.parent_id = ''
			},
		}
	}
</script>

<style>
	.dictionaryClassify {
		box-sizing: border-box;
		height: 100%;
		padding: 2% 12% 0 12%;
		position: relative;
	}
	
	.dictionaryClassify .headerBox {
		position: relative;
		height: 30px;
		line-height: 30px;
		padding: 6px 30px;
		border: 1px solid #EEE;
		border-radius: 3px;
		background-color: #fff;
		font-size: 13px;
		margin-bottom: 10px;
	}
	/*element表格*/
	
	.dictionaryClassify .el-table th {
		color: #000;
	}
	
	.dictionaryClassify .el-table {
		font-size: 12px;
	}
	
	.dictionaryClassify .el-table th,
	.dictionaryClassify .el-table td,
	.dictionaryClassify .el-table tr {
		background-color: #FFF;
		padding: 6px 0!important;
		text-align: left;
	}
	
	.dictionaryClassify .el-table th {
		text-align: left;
		padding: 10px 0!important;
		font-weight: 400;
		color: #999;
	}
	
	.dictionaryClassify .tableBox {
		border-radius: 3px;
		background-color: #fff;
	}
	
	.dictionaryClassify .editClass {
		color: #439DFD;
		margin-right: 10px;
		cursor: pointer;
	}
	
	.dictionaryClassify .addButtonClass {
		position: absolute;
		top: 4px;
		right: 10px;
		padding: 10px 12px;
		font-size: 13px;
		cursor: pointer;
	}
	
	.dictionaryClassify .tableBox {
		padding: 0 20px;
		border: 1px solid #EEE;
		border-radius: 3px;
		background-color: #fff;
	}
	
	.dictionaryClassify .el-form-item {
		margin-bottom: 12px;
	}
	/*element弹窗*/
	
	.dictionaryClassify .el-dialog__title {
		color: #999;
	}
	
	.dictionaryClassify .el-dialog__footer {
		text-align: center;
	}
	
	.dictionaryClassify .pagination {
		text-align: center;
	}
	
	.dictionaryClassify .groupClass {
		margin: 8px;
		height: 22px;
		line-height: 22px;
	}
	
	.dictionaryClassify .groupClass2Box {
		display: inline-block;
		margin: 10px 0 6px 8px;
		width: 30%;
	}
	
	.dictionaryClassify .groupClass2 {
		width: 80%;
		height: 22px;
		line-height: 22px;
	}
	
	.dictionaryClassify .el-form-item__label {
		color: #000;
	}
</style>


// WEBPACK FOOTER //
// src/components/DictionaryManage/DictionaryClassify.vue